export default "__VITE_ASSET__DKQvviFH__"